import React from 'react'
import InterviewPage from '../Interview/InterviewPage'

function Interview() {
  return (
    <>
        <InterviewPage />
    </>
  )
}

export default Interview
